import React from 'react';
import PropTypes from 'prop-types';
import { Components, Utils, translate } from 'versafleet-core';
import DeleteDialog from './deleteDialog';

const TaskDeleteButton = ({
  id = null,
  strings,
  dataId,
}) => (
  <Components.Button
    className="vf-task__delete-button"
    hint={strings.page.buttons.delete}
    iconClassName="versa-delete"
    id={id}
    onClick={(e) => {
      e.stopPropagation();
      Utils.Dialog.DialogManager.open((
        <DeleteDialog
          dataIds={[dataId]}
        />
      ));
    }}
  />
);

TaskDeleteButton.displayName = 'Task Delete Button';

TaskDeleteButton.propTypes = {
  dataId: PropTypes.number.isRequired,
  id: PropTypes.string,
  strings: PropTypes.shape({
    page: PropTypes.shape({
      buttons: PropTypes.shape({
        delete: PropTypes.string,
      }),
    }),
  }).isRequired,
};

export default translate('Task')(TaskDeleteButton);
